export default __webpack_public_path__ + "static/media/LinkedInLogo.7a5eab93.png";